import { useEffect, useMemo, useState } from "react";
import NotificationForm from "../components/form";
import { Spin, Tabs, TabsProps } from "antd";
import styled from "@emotion/styled";
import {
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import CoveyedForm from "../components/form/CoveyedForm";
import apiFactory from "api";
import { INotification } from "constant/interfaces";

const EditNoti: React.FC = () => {
  const { id } = useParams();
  const [notificationDetail, setNotificationDetail] = useState<INotification>();
  const [loading, setLoading] = useState(false);
  const fetchData = async () => {
    setLoading(true);

    try {
      const res = await apiFactory.boardAdminApi.getPostDetail(Number(id));
      setNotificationDetail(res);
    } catch (error) {
      console.error("Error fetching notification detail:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div>
      <div className="page-title">掲示板　親スレッド投稿</div>
      <Spin spinning={loading}>

        <div className="bg-white p-4">
          <div className="max-w-[490px]">
            <CoveyedForm notificationDetail={notificationDetail} isEdit />
          </div>
        </div>
      </Spin>
    </div>
  );
};

export default EditNoti;
